module.exports = __webpack_public_path__ + "img/936279996.f2806741.jpg";